import { render, staticRenderFns } from "./IdCard.vue?vue&type=template&id=a450d3d2&scoped=true&"
import script from "./IdCard.vue?vue&type=script&lang=js&"
export * from "./IdCard.vue?vue&type=script&lang=js&"
import style0 from "./IdCard.vue?vue&type=style&index=0&id=a450d3d2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a450d3d2",
  null
  
)

export default component.exports